"use client";

import { BannerList } from "@lib/data/banner";
import type { StoreProductCategory } from "@medusajs/types";
import { SliderImage } from "@modules/layout/components/slide-image";
import Image from "next/image";
import Link from "next/link";
import CategoriesBanner from "./categories-banner";
import CategoriesHero from "./categories-hero";

export interface ProductCategoryHome {
  productsCount: number;
  handle: string;
  name: string;
  metadata: Record<string, unknown> | null | undefined;
  parent_category_id: string;
}

const Hero = ({
  productCategories,
  main_slider,
  productCategoriesBanner,
  accentColor,
}: {
  productCategories: StoreProductCategory[];
  main_slider: BannerList[];
  productCategoriesBanner: StoreProductCategory[];
  accentColor?: string;
}) => {
  const displayedCategories = productCategories.filter((pro_cat) => !pro_cat.parent_category_id);

  const img_gif = [
    {
      image_url: "https://i.ibb.co/V0r4jBP0/gif-1-800-x-840-px.gif",
      click_url: "#",
      id: 1,
    },
    {
      image_url: "https://i.ibb.co/Q2Gb3FD/gif-2-fixed-800x840.gif",
      click_url: "#",
      id: 2,
    },
  ];

  return (
    <div className="lg:h-[600px] h-[30vh] w-full relative">
      <SliderImage main_slider={main_slider} />
      <div className="py-2"></div>
      <div className="lg:content-container flex w-full bg-red-300 absolute top-[10%] left-0 right-0">
        <div className="lg:flex hidden absolute z-20">
          <CategoriesBanner productCategories={productCategoriesBanner} />
        </div>
        <div className="flex-1 z-0"></div>
        <div className="lg:flex flex-col hidden gap-2 absolute z-10 right-0 pr-6 h-[450px] justify-between">
          {img_gif.map((item) => {
            return (
              <Link key={item.id} href={item.click_url} className="hover:scale-105 transition-all rounded-lg">
                <Image src={item.image_url} alt={item.image_url} width={200} height={200} loading="eager" />
              </Link>
            );
          })}
        </div>
      </div>
      {displayedCategories.length ? (
        <div className="lg:p-5">
          <div className="lg:content-container lg:flex w-full absolute top-[90%] bottom-[-7.5rem] left-1/2 right-1/2 -translate-x-1/2 z-10 lg:px-20">
            <CategoriesHero productCategories={productCategories} accentColor={accentColor} />
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Hero;
